// extracted by mini-css-extract-plugin
export var addToCartButton = "_od-b";
export var arrowButtonContainer = "_od-9";
export var arrowButtonIcon = "_od-a";
export var carouselArrowButton = "_od-6";
export var carouselElementContainer = "_od-1";
export var galleryThumbnail = "_od-d";
export var galleryThumbnailImage = "_od-e";
export var left = "_od-7";
export var productDisplayCarouselContainer = "_od-0";
export var productTileContainer = "_od-2";
export var productTileImage = "_od-4";
export var productTileImageContainer = "_od-3";
export var productTileTitle = "_od-5";
export var right = "_od-8";
export var sliderOverflow = "_od-c";